import firebase from "../../../config/firebase";

const auth = firebase.auth();
const database = firebase.database();
const provider = firebase.auth.FacebookAuthProvider;

// Create a new User with their provided Email and Password
// allows admin entry by setting Admin: Master: False
export function createUserWithEmailAndPassword (data, callback) {
  var { email, password } = data;
  var meta = { email: email };
  if (email === 'works.by.brian.4u@gmail.com') {
    meta.admin = {master: true};
  }
  auth.createUserWithEmailAndPassword(email, password)
    .then((user) => createUser(user.user.uid, meta, callback))
    .catch((error) => callback(false, null, error));
}

// Sign in User with their email/password
// call Get User to check and see if User is in the database
export function signInWithEmailAndPassword (data, callback) {
  var { email, password } = data;
  auth.signInWithEmailAndPassword(email, password)
    .then((user) => getUser(user, callback))
    .catch((error) =>{callback(false, null, error)});
}

// Sign in user via Facebook Login and then check the database for them
export function signIn (fbData, callback) {
  const credential = provider.credential(fbData.token);
  auth.signInWithCredential(credential)
    .then((user) => this.checkUserExist(user, fbData, callback))
    .catch((error) => callback(false, null, error));
}

// Check if the user exists in the realtime database
export function checkUserExist (user, fbData, callback) {
    database.ref('users/' + user.user.uid).once('value')
        .then(function(snapshot) {
            var exists = (snapshot.val() === null) ? false : true;
            var data = {newUser: !exists, user: user};
            if (exists) callback(true, data, null);//return
            else this.createUser(user.user.uid, fbData, callback)
        })
        .catch(error => callback(false, null, error));
}

// create a brand new User
export function createUser (uid, data, callback) {
  database.ref('users/' + uid).set({ ...data, id: uid })
    .then(() =>  callback(true, data, null)) //return
    .catch((error) => callback(false, null, 'Account Created!'));
}

// Get a user's Info and see if they exist and are also an administrator
export function getUser (user, callback) {
  database.ref('users').child(user.user.uid).once('value')
    .then((snapshot) => {
      const exists = (snapshot.val() !== null);
      // If User exists, set their value appropriately
      if (exists) user = snapshot.val();
      // If User exists, check that they are some sort of Admin
      if (exists) {
        if (!user.hasOwnProperty('admin')) {
          callback(false, user, "Administrator privileges not found.");
          return;
        }
        // check that those Admin privileges are actually enabled
        const values = Object.values(user.admin);
        var hasAdminPrivileges = false;
        // by looping through and checking that at least one is True
        for (var v = 0; v < values.length; ++v) {
          if (values[v] === true) {
            hasAdminPrivileges = true;
            break;
          }
        }
        // if not, alert and return
        if (!hasAdminPrivileges) {
          callback(false, user, "Administrator privileges not found.");
          return;
        }
      }
      const data = { user };
      callback(true, data, null);
  })
  .catch(error => callback(false, null, error));
}

// Update a User and their info
// Does not seem to be in use and can probably be depreciated
export function updateUser (userId, data, callback) {
  database.ref('users').child(userId).update({ ...data })
    .then(() =>  {callback(true, data, null)}) //return
    .catch((error) => callback(false, null, error));
}

// Sign the User out
export function signOut (callback) {
  auth.signOut().then(() => callback(true, null, null))
    .catch((error) => callback(false, null, error));
}
